const PASSKEY_FLAG_KEY = 'coolmate:hasPasskey';

export function setPasskeyFlag(hasPasskey: boolean): void {
  if (typeof window === 'undefined') {
    return;
  }

  if (hasPasskey) {
    localStorage.setItem(PASSKEY_FLAG_KEY, 'true');
  } else {
    localStorage.removeItem(PASSKEY_FLAG_KEY);
  }
}

export function getPasskeyFlag(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return localStorage.getItem(PASSKEY_FLAG_KEY) === 'true';
}
